export default "__VITE_ASSET__CB4wMVe0__"